import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatopuneonewaycab() {



const cardData =
{
  keyword: 'Goa to Pune One Way Cab  ',

  heading: 'Lotus Cab: Goa to Pune One Way Cab  ',

headingDescription:
  "Lotus Cabs provides reliable and affordable Goa to Pune One Way Cab services for family travel, corporate trips, business meetings, airport transfers, student travel, holiday returns, and last-minute travel needs. Our premium fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, all driven by professional and experienced chauffeurs. Enjoy transparent one-way pricing with no hidden charges, 24x7 booking support, doorstep pickup from any location in Goa, well-maintained vehicles, and safe long-distance highway travel. Lotus Cabs ensures a comfortable, punctual, and hassle-free one-way journey from Goa to Pune.",

  top: 'Top Places to Visit in Pune before Traveling to Goa with Lotus Cab',

topPlaces: [
    {
        title: "Lal Mahal",
        description:
            "Lal Mahal is one of Pune's most historically significant landmarks, built by Shahaji Maharaj for Jijabai and young Chhatrapati Shivaji Maharaj. The reconstructed palace showcases important moments from Maratha history through beautiful exhibits and sculptures, making it a popular destination for history enthusiasts."
    },
    {
        title: "Parvati Hill Temple",
        description:
            "Parvati Hill Temple is a renowned hilltop temple complex dedicated to Lord Shiva and Goddess Parvati. Visitors climb over 100 steps to enjoy panoramic views of Pune city, peaceful surroundings, and the historical temples built during the Peshwa era."
    },
    {
        title: "Saras Baug",
        description:
            "Saras Baug is a beautiful public garden famous for its lush greenery and the historic Siddhivinayak Temple situated at its center. It is a favorite spot for families, joggers, and visitors looking to relax amidst nature in the heart of Pune."
    },
    {
        title: "Vetal Tekdi",
        description:
            "Vetal Tekdi is the highest hill in Pune and a paradise for nature lovers, trekkers, and fitness enthusiasts. The hill offers scenic walking trails, fresh air, abundant greenery, and spectacular sunrise and sunset views over the city."
    },
    {
        title: "Empress Garden",
        description:
            "Empress Garden is a sprawling botanical garden featuring colorful flowers, rare plant species, landscaped lawns, and peaceful walking paths. It is an ideal destination for picnics, photography, and enjoying nature with family and friends."
    },
    {
        title: "Okayama Friendship Garden",
        description:
            "Okayama Friendship Garden, also known as Pune-Okayama Garden, is a beautifully landscaped Japanese-style garden inspired by the famous Korakuen Garden of Japan. Its ponds, bridges, waterfalls, and manicured lawns create a calm and refreshing atmosphere."
    },
    {
        title: "National War Memorial Southern Command",
        description:
            "The National War Memorial Southern Command honors the brave soldiers of the Indian Armed Forces who sacrificed their lives for the nation. Featuring military displays, monuments, and informative exhibits, it is an inspiring destination for visitors interested in India's military history."
    },
    {
        title: "Pune-Okayama Garden",
        description:
            "Pune-Okayama Garden is a serene landscaped park known for its Japanese-inspired architecture, flowing streams, decorative bridges, and lush greenery. The garden provides a peaceful retreat for morning walks, photography, and relaxation."
    },
    {
        title: "Katraj Lake",
        description:
            "Katraj Lake is a tranquil freshwater lake surrounded by scenic hills and natural beauty. Visitors often come here for peaceful evening walks, birdwatching, and enjoying the calm atmosphere away from the city's busy streets."
    },
    {
        title: "Chaturshringi Temple",
        description:
            "Chaturshringi Temple is one of Pune's most revered Hindu temples dedicated to Goddess Chaturshringi. Located on a hillside, the temple is especially crowded during Navratri and offers beautiful views of the surrounding city along with a spiritually uplifting experience."
    }
],





"services": [
  {
    "name": "Goa to Pune One Way Cab",
    "description": "Book a Goa to Pune one way cab for comfortable and affordable intercity travel with transparent pricing and professional drivers."
  },
  {
    "name": "Goa to Pune One Way Taxi",
    "description": "Reliable Goa to Pune one way taxi service offering direct transfers with clean vehicles and convenient pickup options."
  },
  {
    "name": "Goa to Pune Cab",
    "description": "Comfortable Goa to Pune cab service available for one-way and outstation travel with sedan, SUV, and premium vehicle options."
  },
  {
    "name": "Goa to Pune Taxi",
    "description": "Professional Goa to Pune taxi service for families, tourists, and business travelers seeking safe and hassle-free transportation."
  },
  {
    "name": "Goa to Pune One Side Cab",
    "description": "Affordable Goa to Pune one side cab service where passengers pay only for a single journey without return charges."
  },
  {
    "name": "Goa to Pune One Way Taxi Service",
    "description": "Convenient Goa to Pune one way taxi service with experienced drivers and comfortable AC vehicles for long-distance travel."
  },
  {
    "name": "Goa to Pune One Way Cab Booking",
    "description": "Easy Goa to Pune one way cab booking with instant confirmation, transparent fares, and multiple vehicle choices."
  },
  {
    "name": "Goa to Pune Affordable One Way Cab",
    "description": "Budget-friendly Goa to Pune affordable one way cab service designed for economical and comfortable intercity travel."
  },
  {
    "name": "Goa to Pune Outstation Cab",
    "description": "Reliable Goa to Pune outstation cab service offering safe and smooth long-distance travel with professional chauffeurs."
  },
  {
    "name": "Goa to Pune Private Taxi",
    "description": "Private Goa to Pune taxi service providing exclusive travel experience with flexible departure timings and premium comfort."
  },
  {
    "name": "Goa to Pune Sedan Cab",
    "description": "Comfortable Goa to Pune sedan cab service ideal for solo travelers, couples, and small families."
  },
  {
    "name": "Goa to Pune Innova Cab",
    "description": "Spacious Goa to Pune Innova cab service perfect for family trips and group travel with extra luggage space."
  },
  {
    "name": "Goa to Pune Ertiga Cab",
    "description": "Affordable Goa to Pune Ertiga cab service with comfortable seating for families and small groups."
  },
  {
    "name": "Goa to Pune SUV Cab",
    "description": "Premium Goa to Pune SUV cab service offering spacious interiors and a comfortable ride for long-distance journeys."
  },
  {
    "name": "Goa to Pune AC Cab",
    "description": "Travel comfortably with Goa to Pune AC cab service featuring air-conditioned vehicles and experienced drivers."
  },
  {
    "name": "Goa to Pune Cab Fare One Way",
    "description": "Get transparent Goa to Pune cab fare one way details with clear pricing based on distance and vehicle type."
  },
  {
    "name": "Goa to Pune Taxi Fare One Way",
    "description": "Affordable Goa to Pune taxi fare one way plans with upfront pricing and no hidden charges."
  },
  {
    "name": "Goa to Pune One Way Cab Price",
    "description": "Check Goa to Pune one way cab price options for sedans, SUVs, and premium vehicles with flexible packages."
  },
  {
    "name": "Goa to Pune Airport Drop Cab",
    "description": "Convenient Goa to Pune airport drop cab service with timely pickup from Goa and direct drop-off in Pune."
  },
  {
    "name": "Best Goa to Pune One Way Cab",
    "description": "Best Goa to Pune one way cab service offering reliable drivers, well-maintained vehicles, and excellent customer support."
  }
],

"tableData": [
  ["Goa to Pune One Way Cab", "Goa to Pune One Way Taxi"],
  ["Goa to Pune Cab", "Goa to Pune Taxi"],
  ["Goa to Pune One Side Cab", "Goa to Pune One Way Taxi Service"],
  ["Goa to Pune One Way Cab Booking", "Goa to Pune Affordable One Way Cab"],
  ["Goa to Pune Outstation Cab", "Goa to Pune Private Taxi"],
  ["Goa to Pune Sedan Cab", "Goa to Pune Innova Cab"],
  ["Goa to Pune Ertiga Cab", "Goa to Pune SUV Cab"],
  ["Goa to Pune AC Cab", "Goa to Pune Cab Fare One Way"],
  ["Goa to Pune Taxi Fare One Way", "Goa to Pune One Way Cab Price"],
  ["Goa to Pune Airport Drop Cab", "Best Goa to Pune One Way Cab"]
],






"whychoose": [
  {
    "WhyChooseheading": "Affordable One Way Travel",
    "WhyChoosedescription": "Pay only for your drop journey with economical one-way cab fares from Goa to Pune."
  },
  {
    "WhyChooseheading": "No Return Fare Charges",
    "WhyChoosedescription": "Enjoy cost-effective travel without paying for the driver's return trip."
  },
  {
    "WhyChooseheading": "Multiple Cab Options",
    "WhyChoosedescription": "Choose from Sedan, Ertiga, Innova Crysta, and SUV vehicles according to your requirements."
  },
  {
    "WhyChooseheading": "Direct Pickup from Any Location",
    "WhyChoosedescription": "Convenient pickup services available from Goa Airport, hotels, resorts, and homes."
  },
  {
    "WhyChooseheading": "Comfortable AC Vehicles",
    "WhyChoosedescription": "Travel in clean, spacious, and air-conditioned cabs for a relaxing journey."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Professional chauffeurs ensure a safe and smooth ride on highway and ghat routes."
  },
  {
    "WhyChooseheading": "Flexible Departure Timings",
    "WhyChoosedescription": "Book your one-way cab at a time that best suits your travel schedule."
  },
  {
    "WhyChooseheading": "24/7 Booking Support",
    "WhyChoosedescription": "Our support team is available round the clock for bookings and travel assistance."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Goa to Pune one way cab service?',
    answer: 'Yes, Lotus Cab offers reliable one-way cab services from Goa to Pune at affordable and transparent rates.'
  },
  {
    question: 'What is the distance between Goa and Pune by road?',
    answer: 'The distance between Goa and Pune is approximately 450 km, and the journey generally takes around 8 to 10 hours depending on traffic and route conditions.'
  },
  {
    question: 'How much does a Goa to Pune one way cab cost?',
    answer: 'The fare depends on the vehicle type, pickup location, and travel date. Lotus Cab offers competitive pricing with no hidden charges.'
  },
  {
    question: 'Do I need to pay return charges for a one-way trip?',
    answer: 'No, our one-way cab service is designed to save money by charging only for the required drop journey.'
  },
  {
    question: 'Which vehicles are available for Goa to Pune one-way travel?',
    answer: 'We provide Sedan cars, Ertiga, Innova Crysta, and spacious SUVs for individual, family, and group travel.'
  },
  {
    question: 'Can I get pickup from Goa Airport?',
    answer: 'Yes, we offer convenient pickup services from Goa Airport, railway stations, hotels, and other locations.'
  },
  {
    question: 'Are toll and state taxes included in the fare?',
    answer: 'Toll charges, parking fees, and state border taxes are generally charged separately unless mentioned in the package.'
  },
  {
    question: 'Is night pickup available from Goa to Pune?',
    answer: 'Yes, Lotus Cab provides day and night pickup options to match your travel schedule.'
  },
  {
    question: 'Can I pre-book my one-way cab in advance?',
    answer: 'Absolutely. Advance booking is recommended to ensure vehicle availability and better travel planning.'
  },
  {
    question: 'How can I book a Goa to Pune One Way Cab with Lotus Cab?',
    answer: 'Share your pickup location, travel date, passenger count, and preferred vehicle to receive an instant quotation and booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Joshi',
    feedback: 'I was looking for an economical one-way ride back to Pune after my holiday in Goa. Lotus Cab provided a clean car and the entire trip was comfortable from start to finish.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Patwardhan',
    feedback: 'The one-way cab option helped us avoid unnecessary return charges. The driver was friendly, punctual, and the journey to Pune was completely hassle-free.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Goa to Pune One Way Cab",
"image": "https://lotuscab.com/assets/images/goa-to-pune-one-way-cab.jpg",
"description": "Book Goa to Pune One Way Cab with Lotus Cab for safe, comfortable, and affordable outstation travel. Enjoy reliable one way taxi service with sedan, Innova, Ertiga, and SUV cabs for business trips, family travel, airport transfers, and long distance journeys with professional drivers available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/goa-to-pune-one-way-cab"
}
};






  return (
    <div>
      



<Helmet>
  <title>Goa to Pune One Way Cab | Affordable One Way Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Goa to Pune One Way Cab with Lotus Cab for comfortable and affordable outstation travel. Get one way taxi service with sedan, Innova, Ertiga, and SUV cabs along with professional drivers and 24x7 cab booking service."
/>

<meta
 name="keywords"
 content="Goa to Pune One Way Cab, Goa to Pune One Way Taxi, Goa to Pune Cab, Goa to Pune Taxi, Goa to Pune One Side Cab, Goa to Pune One Way Taxi Service, Goa to Pune One Way Cab Booking, Goa to Pune Affordable One Way Cab, Goa to Pune Outstation Cab, Goa to Pune Private Taxi, Goa to Pune Sedan Cab, Goa to Pune Innova Cab, Goa to Pune Ertiga Cab, Goa to Pune SUV Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goatopuneonewaycab;